import React, {Component} from 'react';
import { connect} from 'react-redux'
import {bindActionCreators, compose} from 'redux'
import CTable from '@/components/CTable'
import CButton from '@/components/CButton'
import CBaseComponent from '@/components/CBaseComponent'
import CSelect from '@/components/CForm/CSelect'
import CRadio from '@/components/CForm/CRadio'
import CInput from '@/components/CForm/CInput'
import { setReload } from "@/redux/common/action";
import { setStorage} from "@/utils";
import { tableData} from './data'
import './index.scss'

import { selectLibraryHeader } from "@/servers/goodsManageApi";
import {withRouter} from "react-router-dom";
import {Button, message, Modal} from 'antd'
import {getALLMenu} from "../../../../servers/menuAPI";
import {setLbname, setLibrary, setMenu, setYear} from "../../../../redux/common/action";
@CBaseComponent
class GoodsManageList extends Component{
    constructor(props) {
        super(props);
        this.getListData = this.getListData.bind(this);
        this.deleteHandler = this.deleteHandler.bind(this);
        this.modalOk = this.modalOk.bind(this);
        this.modalCancel = this.modalCancel.bind(this);
        this.searchHandler = this.searchHandler.bind(this)
        this.resetHandler = this.resetHandler.bind(this)
        this.onChange = this.onChange.bind(this)
        this.onChangeName = this.onChangeName.bind(this)
        this.onChangelevel = this.onChangelevel.bind(this)
        this.changeitem = this.changeitem.bind(this)
        this.gotoindex =  this.gotoindex.bind(this)
        this.onTableChange = this.onTableChange.bind(this)
    }

    componentWillReceiveProps(nextProps) {
        // reload时重新加载数据
        // this.getListData();
    }


    state = {
        columns: tableData.tHead,
        dataSource: tableData.tBody,
        dataSourceAll:[],
        page: tableData.tPage,
        loading: true,
        level:0,
        modal: {
            title: '删除数据',
            visible: false,
        },
        deleteid:'',
        annual: '',
        levelid: '',
        ownerlist:[],
        options:[],
        citylist:[],
        detaildata:[],
        museumname:'',
        provinceid:''
    };


    searchHandler(){
        this.getListData()
    }

    onChange(data){
        this.setState({
            provinceid:data
        })
    }

    onChangeName(data){
        this.setState({
            museumname:data
        })
    }

    onChangelevel(data){
        this.setState({
            levelid:data
        })
    }

    resetHandler(){
        this.setState({
            provinceid:'',
            levelid: '',
            museumname:''
        },()=>{
            this.getListData()
        })
    }

    modalCancel(){
        this.setState({
            modal: {...this.state.modal, visible: false},
            deleteid:''
        })
    }

    modalOk(){
        // const params = {
        //   id: this.state.deleteid
        // }
        // expertdelete(params).then(res=>{
        //   if (res.statecode === 0) {
        //     message.success('删除成功');
        //     this.modalCancel()
        //     this.getListData()
        //   } else {
        //     message.error('删除失败');
        //   }
        // })
    }

    onTableChange(data){
        let d = JSON.parse(JSON.stringify(this.state.dataSourceAll))
        var bIndex = parseInt(data.data.pageSize) * (parseInt(data.data.page) - 1);
        var eIndex = parseInt(bIndex) + parseInt(data.data.pageSize);
        var newDataList = [];
        for(var i = bIndex;i < eIndex;i++){
            if (d[i]) {
                newDataList.push(d[i]);
            }
        }
        this.setState({
            page: {...this.state.page, ...data.data},
            dataSource:newDataList
        })
    }

    changeitem(data){
        data.forEach(item=>{
            item.showids = item.id
            if (item.children){
                this.changeitem(item.children)
            }
        })
        return data
    }

    gotoindex(data,year){
        const params = {
            annual:year,
            museumid:data.id
        }
        getALLMenu(params).then(res=>{
            const result =  this.changeitem(res.records)
            setStorage('menu', result);
            this.props.setMenu(result);
            setStorage('year', year);
            this.props.setYear(year);
            setStorage('lbname', data.name);
            this.props.setLbname(data.name);
            setStorage('showids','1.1.1')
            this.props.setLibrary(data.id);
            setStorage('library',data.id)
            this.props.history.push({
                pathname: '/informationDeclaration/museumbaseinfoProvince',
            });
        })
    }

    // 获取用户列表数据
    getListData(){
        this.setState({
            loading: true
        });
        const params = {
            levelid:this.state.levelid,
            provinceid:this.state.provinceid === -1 ? '' : this.state.provinceid,
            museumname:this.state.museumname
        }
        selectLibraryHeader(params).then(res=>{
            if (res.statecode === 0) {
                const arr = []
                res.records[0].levellist.forEach(item=>{
                    item.value = item.id
                })
                res.records[0].annuallist.forEach(item=>{
                    let obj = {}
                    obj.name = item
                    obj.value = item
                    arr.push(obj)

                })
                res.records[0].provincelist.forEach((item,index)=>{
                    if (index === 0) {
                        item.id = -1
                    }
                    item.value = item.id
                })
                let d = JSON.parse(JSON.stringify(res.records[0].museumlist))
                let  data = d.splice((this.state.page.page-1)*this.state.page.pageSize,this.state.page.page*this.state.page.pageSize)

                this.setState({
                    dataSource: data,
                    dataSourceAll:res.records[0].museumlist,
                    ownerlist: arr,
                    options: res.records[0].levellist,
                    loading:false,
                    citylist:res.records[0].provincelist,
                    page: {...this.state.page, total:res.records[0].museumlist.length},
                });
            }
        }).catch(err=>{
            console.log(err,'rttt')
        })
    }
    deleteHandler(data){
        const params =
            {
                id:data.id
            }
        // specialadddetailHanndler(params).then(res=>{
        //     if (res.statecode === 0) {
        //         this.setState({
        //             detaildata:res.records,
        //             modal: {...this.state.modal, visible: true},
        //         })
        //     }
        // })
        // this.setState({
        //   modal: {...this.state.modal, visible: true},
        //   deleteid:data.id
        // })
    }


    componentWillMount(){

    }

    componentDidMount(){
        this.getListData();
    }

    render(){
        return (
            <div className='user-manage-list'>
                <div className='flex filter-wrap'>
                    <div className='flex filter-left' style={{width:'100%'}}>
                        <CInput
                            value={this.state.museumname}
                            placeholder='请输入名称'
                            style={{width:'200px'}}
                            onChange={this.onChangeName}
                        />
                        {/*<CSelect*/}
                        {/*    value={this.state.provinceid}*/}
                        {/*    options={this.state.citylist}*/}
                        {/*    placeholder='请选择所处省份'*/}
                        {/*    onChange={this.onChange}*/}
                        {/*    style={{width:'100px'}}*/}
                        {/*/>*/}
                        <CRadio value={this.state.levelid}
                                options={this.state.options}
                                onChange={this.onChangelevel}
                        />
                        <CButton type='primary' onClick={this.searchHandler}>查询</CButton>
                    </div>
                </div>
                <CTable ref='userManageList' checked={false} loading={this.state.loading} columns={this.state.columns} dataSource={this.state.dataSource} page={this.state.page} onTableChange={this.onTableChange}>
                    <div
                        slot='index'
                        render={(text, record, index) => (
                            <div className='operate'>
                                {index+1}
                            </div>
                        )} />
                    <div
                        slot='select1'
                        render={(text, record, index) => (
                            <div className='operate'>
                                <CButton type='text' authId='goodsManageListEdit' onClick={() => this.gotoindex(record,'2019')}>查看</CButton>
                            </div>
                        )} />
                    <div
                        slot='select2'
                        render={(text, record, index) => (
                            <div className='operate'>
                                <CButton type='text' authId='goodsManageListEdit' onClick={() => this.gotoindex(record,'2020')}>查看</CButton>
                            </div>
                        )} />
                    <div
                        slot='select3'
                        render={(text, record, index) => (
                            <div className='operate'>
                                <CButton type='text' authId='goodsManageListEdit' onClick={() => this.gotoindex(record,'2021')}>查看</CButton>
                            </div>
                        )} />
                </CTable>
                <Modal
                    visible={this.state.modal.visible}
                    onOk={this.modalOk}
                    onCancel={this.modalCancel}
                    closable={false}
                    width={500}
                >
                    <div className='detail-container' >
                        <div>
                            <h4 style={{marginBottom:'20px'}}>{this.state.detaildata.length>0?this.state.detaildata[0].museumname+'特色加分评分详情':''}</h4>
                            {this.state.detaildata.length>0?
                                this.state.detaildata[0].scoredetaillist.map((item,index)=>{
                                    return (<div style={{display:'flex',borderBottom:'1px solid #bebebe'}}>
                                        {
                                            item.map(item2=>{
                                                return (
                                                    <div style={{flex:1,textAlign:'center',marginBottom:'10px',alignItems:'center'}}>{item2}</div>
                                                )
                                            })
                                        }
                                    </div>)
                                }):''
                            }
                        </div>
                        {this.state.detaildata.map((item,index)=>{
                            return (
                                <div className="detail-item" style={{filter:'none'}}>
                                    <div className='detail-title'>
                                        <span>{item.name}</span>
                                    </div>
                                    <div className='detail-content'>
                                        {item.fillin}
                                    </div>
                                    <ul className='uploadlistScore'>
                                        {
                                            item.annexlist.length>0?
                                                item.annexlist.map((item1,index1)=>{
                                                    return <li>
                                                        <span>{index1+1}.{item1.filename}</span>
                                                        <div>
                                                            <span className="textbtn" onClick={()=>{this.downloads(item1)}}>下载</span>
                                                            <span className="textbtn" onClick={()=>{this.handlePreview(item1)}}>预览</span>
                                                        </div>
                                                    </li>
                                                }):''
                                        }
                                    </ul>
                                </div>
                            )
                        })}
                    </div>
                </Modal>
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        reload: state.reload,
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        setReload: bindActionCreators(setReload, dispatch),
        setMenu:bindActionCreators(setMenu,dispatch),
        setYear:bindActionCreators(setYear,dispatch),
        setLibrary:bindActionCreators(setLibrary,dispatch),
        setLbname:bindActionCreators(setLbname,dispatch),
    }
};

export default compose(withRouter, connect(mapStateToProps, mapDispatchToProps))(GoodsManageList);
